import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Component, signal } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';

export interface AgDropdownViewComponentParams {
  disabled?: boolean;
}

@Component({
  imports: [IconComponent],
  styles: [
    `
      :host {
        overflow: hidden;
      }
    `,
  ],
  template: `
    <div class="relative flex min-h-5 items-center justify-between">
      <p class="truncate">{{ value() }}</p>

      <div class="absolute right-[-9px] flex items-center space-x-2">
        @if (!params.disabled) {
          @if (value()) {
            <aux-icon
              name="X"
              [size]="12"
              class="cursor-pointer hover:text-aux-error"
              (click)="onClear()"
            />
          }

          <div class="ag-picker-field-icon">
            <span class="ag-icon ag-icon-small-down" role="presentation"></span>
          </div>
        }
      </div>
    </div>
  `,
})
export class AgDropdownViewComponent implements ICellRendererAngularComp {
  value = signal<string>('');

  params!: AgDropdownViewComponentParams & ICellRendererParams;

  agInit(params: AgDropdownViewComponentParams & ICellRendererParams): void {
    this.value.set(params.valueFormatted ?? params.value);
    this.params = params;
  }

  onClear() {
    if (this.params.node && this.params.column) {
      const field = this.params.column.getColDef().field;

      this.value.set('');

      if (field) {
        this.params.node.setDataValue(field, null);
        this.params.api.refreshCells({
          columns: [field],
          force: true,
          rowNodes: [this.params.node],
        });
      }
    }
  }

  refresh() {
    return false;
  }
}
